import React, { useState } from "react";

function CounterHook() {
    const [count, setCount] = useState(10)

  return (
    <div className="counter-card">
      <h1>Function Based Counter: Using Hooks</h1>
      <h2>{count}</h2>
      <div className="button-group">
        <button onClick={()=>setCount(count+1)} type="button">
          Plus
        </button>
        <button onClick={()=>setCount(count-1)} className="minus" type="button">
          Minus
        </button>
      </div>
    </div>
  );
}

export default CounterHook;
